import { z } from "zod";
import { listQuerySchema, moneyField, optionalText, optionalUuid, quantityField, } from "./common.js";
export const rfqSchema = z.object({
    customerId: z.string().uuid("Invalid customer id."),
    description: optionalText(4000),
    requestedDate: z.string().date().optional(),
    source: z
        .enum(["phone", "walk_in", "email", "referral", "website", "other"])
        .default("phone"),
});
export const quoteCreateSchema = z.object({
    customerId: z.string().uuid("Invalid customer id."),
    rfqId: z.string().uuid().optional(),
    validUntil: z.string().date().optional(),
    leadTimeDays: z.number().int().min(0).max(3650).optional(),
    notes: optionalText(4000),
});
export const quoteLineSchema = z.object({
    kind: z.enum(["product", "custom"]).default("custom"),
    productRevisionId: optionalUuid(),
    description: optionalText(300),
    quantity: quantityField,
    unitPrice: moneyField,
});
export const quoteLineUpdateSchema = z.object({
    description: z.string().trim().min(1, "Description is required.").max(300).optional(),
    quantity: quantityField.optional(),
    unitPrice: moneyField.optional(),
});
export const estimateLineSchema = z.object({
    kind: z.enum(["material", "labor", "work_center", "outsourced", "fixed"]),
    description: optionalText(300),
    quantity: z
        .string()
        .trim()
        .regex(/^\d+(\.\d{1,4})?$/, "Invalid quantity.")
        .optional(),
    unitCost: moneyField,
    markupPercent: z.number().min(0).max(1000).default(0),
    workCenterId: optionalUuid(),
});
export const estimatesSchema = z.object({
    estimates: z.array(estimateLineSchema).max(50),
});
export const declineBodySchema = z.object({
    reason: z.string().trim().min(3, "A short reason is required.").max(500).optional(),
});
export const quoteListQuerySchema = listQuerySchema.extend({
    status: z.enum(["draft", "sent", "accepted", "declined", "expired"]).optional(),
    customerId: z.string().uuid().optional(),
});
export const quoteIdParamSchema = z.object({
    id: z.string().uuid("Invalid quote id."),
});
export const revisionIdParamSchema = z.object({
    id: z.string().uuid("Invalid quote id."),
    revisionId: z.string().uuid("Invalid revision id."),
});
export const quoteLineIdParamSchema = z.object({
    id: z.string().uuid("Invalid quote id."),
    revisionId: z.string().uuid("Invalid revision id."),
    lineId: z.string().uuid("Invalid line id."),
});
export const orderIdParamSchema = z.object({
    id: z.string().uuid("Invalid order id."),
});
//# sourceMappingURL=sales.js.map